import executeGraphLink from '../links/executeGraphLink';
import { remoteGraphLink } from '../links/remoteGraphLink';
import { localRemoteRouterLink } from '../links/localRemoteRouterLink';
import { Resolvers, ResolverContext } from 'owa-graph-schema';
import { LazyImport, LazyBootModule } from 'owa-bundling-light';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

export type ResolverImports = {
    offline?: LazyImport<Resolvers<ResolverContext>, LazyBootModule<any>>;
    web: LazyImport<Resolvers<ResolverContext>, LazyBootModule<any>>;
};

/**
 * This is a link used exclusively on the worker to execute the graph directly from the execute method of the DataWorkerClient
 */
export async function createGraphServerLink(
    context: Record<string, any>,
    resolverImports: ResolverImports
) {
    const lazyResolvers =
        resolverImports.offline && isHostAppFeatureEnabled('offlineResolvers')
            ? resolverImports.offline.import()
            : resolverImports.web.import();

    const resolvers = await lazyResolvers;
    const localLink = executeGraphLink(resolvers, context);
    const remoteLink = remoteGraphLink();
    return localRemoteRouterLink({
        localLink,
        remoteLink,
        resolvers,
    });
}
